import React, { lazy } from 'react';

// Login 
const LoginSimple = lazy(() => import('../Components/Pages/Auth/Login'));
const LoginOne = lazy(() => import('../Components/Pages/Auth/LoginOne'));
const LoginTwo = lazy(() => import('../Components/Pages/Auth/LoginTwo'));
const LoginValidation = lazy(() => import('../Components/Pages/Auth/LoginValidation'));
const LoginTooltip = lazy(() => import('../Components/Pages/Auth/LoginTooltip'));
const LoginSweetalert = lazy(() => import('../Components/Pages/Auth/LoginSweetalert'));

//Register pages
const RegisterSimple = lazy(() => import('../Components/Pages/Auth/RegisterSimple'));
const RegisterBgImg = lazy(() => import('../Components/Pages/Auth/RegisterBgImg'));
const RegisterVideo = lazy(() => import('../Components/Pages/Auth/RegisterVideo'));
const UnlockUser = lazy(() => import('../Components/Pages/Auth/UnlockUser'));
const ForgotPwd = lazy(() => import('../Components/Pages/Auth/ForgetPwd'));
const ResetPwd = lazy(() => import('../Components/Pages/Auth/ResetPassword'));
const Maintenance = lazy(() => import('../Components/Pages/Auth/Maintenance'));
const EmailOtp = lazy(() => import("../Billerq/Sign/EmailOtp"));

//ComingSoon Pages
const Comingsimple = lazy(() => import('../Components/Pages/CommingSoon/ComingSimple'));
const Comingwithbgvideo = lazy(() => import('../Components/Pages/CommingSoon/ComingwithbgVideo'));
const ComingbgImage = lazy(() => import('../Components/Pages/CommingSoon/ComingSoonbgImg'));
const Error_page1 = lazy(() => import('../Components/Pages/ErrorForLogin/Error_page1'));
const Error_page2 = lazy(() => import('../Components/Pages/ErrorForLogin/Error_page2'));
const Error_page3 = lazy(() => import('../Components/Pages/ErrorForLogin/Error_page3'));
const Error_page4 = lazy(() => import('../Components/Pages/ErrorForLogin/Error_page4'));
const Error_page5 = lazy(() => import('../Components/Pages/ErrorForLogin/Error_page5'));

export const authRoutes = [  
  //Login and Register pages
  { path: `${process.env.PUBLIC_URL}/pages/auth/login-simple`, Component: <LoginSimple /> },
  { path: `${process.env.PUBLIC_URL}/pages/auth/login-bg-img`, Component: <LoginOne /> },
  { path: `${process.env.PUBLIC_URL}/pages/auth/login-img`, Component: <LoginTwo /> },
  { path: `${process.env.PUBLIC_URL}/pages/auth/login-validation`, Component: <LoginValidation /> },
  { path: `${process.env.PUBLIC_URL}/pages/auth/login-tooltip`, Component: <LoginTooltip /> },
  { path: `${process.env.PUBLIC_URL}/pages/auth/login-sweetalert`, Component: <LoginSweetalert /> },
  { path: `${process.env.PUBLIC_URL}/pages/auth/register-simple`, Component: <RegisterSimple /> },
  { path: `${process.env.PUBLIC_URL}/pages/auth/register-bg-img`, Component: <RegisterBgImg /> },
  { path: `${process.env.PUBLIC_URL}/pages/auth/sign-up-two`, Component: <RegisterVideo /> },
  { path: `${process.env.PUBLIC_URL}/pages/auth/unlock-user`, Component: <UnlockUser /> },
  { path: `${process.env.PUBLIC_URL}/forget-pwd`, Component: <ForgotPwd /> },
  { path: `${process.env.PUBLIC_URL}/email-otp`, Component: <EmailOtp /> },
  { path: `${process.env.PUBLIC_URL}/pages/auth/reset-pwd`, Component: <ResetPwd /> },  
  { path: `${process.env.PUBLIC_URL}/pages/auth/maintenance`, Component: <Maintenance /> },
 
  // coming soon
  { path: `${process.env.PUBLIC_URL}/pages/comingsimple/coming-bg-video`, Component: <Comingwithbgvideo /> },  
  { path: `${process.env.PUBLIC_URL}/pages/comingsimple/coming-bg-img`, Component: <ComingbgImage /> },
  // { path: `${process.env.PUBLIC_URL}/pages/comingsimple/comingsoon`, Component: <Comingsimple /> },

  //Error
  { path: `${process.env.PUBLIC_URL}/login/pages/error/error-page1`, Component: <Error_page1/> },
  { path: `${process.env.PUBLIC_URL}/login/pages/error/error-page2`, Component: <Error_page2/> },
  { path: `${process.env.PUBLIC_URL}/login/pages/error/error-page3`, Component: <Error_page3/> },
  { path: `${process.env.PUBLIC_URL}/login/pages/error/error-page4`, Component: <Error_page4/> },
  { path: `${process.env.PUBLIC_URL}/login/pages/error/error-page5`, Component: <Error_page5/> },

];
